module.exports = __webpack_public_path__ + "static/media/image8.5effeb7a.jpg";